import * as React from 'react';

import {Button} from 'shells/button/button';
import type {ButtonSize} from 'shells/button/types';

import {CreateManagedMeetingModal} from './create-managed-meeting-modal';

type Props = {
    size?: ButtonSize;
};

export function CreateManagedMeetingButton(props: Props) {
    const [isCreating, setIsCreating] = React.useState<boolean>(false);

    return (
        <>
            <Button
                variant='primary'
                size={props.size || 'big'}
                onClick={() => setIsCreating(true)}
            >
                Create managed meeting
            </Button>
            {isCreating && <CreateManagedMeetingModal onClose={() => setIsCreating(false)} />}
        </>
    );
}
